import React, { Component } from "react";
import { connect } from "react-redux";

import RaisedButton from "material-ui/RaisedButton";
import TextField    from "material-ui/TextField";

import ErrorMessage from "../Components/component_MsgError";
import "../CSS/style_upgrade.css";
import { checkEmail, checkCap, checkNull, checkPivaForm, checkEmailForm, checkCapForm , checkPassword, checkUserLanguage} from "../Utils/Check_Value";
import { paymentConfig, paymentPrices } from "../Actions/Action_ServiceRequest_Pagamento";
import { registerCloud, registerPro } from "../Actions/Action_ServiceRequest_Registrazione";

import IconArrowBack    from "material-ui/svg-icons/navigation/arrow-back";
import IconArrowForward from "material-ui/svg-icons/navigation/arrow-forward";
import IconCheck        from "material-ui/svg-icons/navigation/check";

import * as PAGESSWITCH from "../Utils/PagesSwitch.js";
import * as ROLES from "../Utils/Roles_Types";
import { Root } from "../Utils/Strings/Route";
import PaypalExpressBtn from "react-paypal-express-checkout";
import { LABEL_Enter_Username, LABEL_Username, LABEL_PasswordNotEquals, LABEL_Enter_Password, LABEL_Password, LABEL_PasswordOKConfirm, LABEL_Required, LABEL_BusinessName,
         LABEL_Enter_City, LABEL_Enter_Email, LABEL_Enter_District, LABEL_Enter_Cap, LABEL_Enter_Piva, LABEL_Enter_BusinessName,LABEL_PaymentOK,
        LABEL_Email, LABEL_City,LABEL_Invalid_Piva,LABEL_ChooseVersione,LABEL_Enter_Description, LABEL_Description, LABEL_Name, LABEL_Enter_Name, LABEL_Holding, LABEL_Invalid_Cap, LABEL_Piva, LABEL_Cap,LABEL_Invalid_Email,  LABEL_District, LABEL_Address, LABEL_Enter_Address } from "../Utils/Strings/Labels";
import {logout} from "../Actions/Action_Authentication";
/*
    Ci sono diversi step 
    0: -> inserimento dati fatturazione
    1: -> inserimento dati holding
    2: -> pagamento

    se un utente deve passare dalla FREE ALLA PRO
        0, 2
    se un utente passa dalla PRO ALLA CLOUD
        1, 2 
*/

const USERINFO = JSON.parse(localStorage.getItem(ROLES.USERINFO_KEY));
const USERLANGUAGE  = checkUserLanguage(USERINFO);

class Upgrade extends Component {
  constructor(props) {
    super(props);
    var params = PAGESSWITCH.locationSearchToParams(this.props.location.search);
    var IDRole = PAGESSWITCH.searchInParamsList("UIDR", params);
    var steps = IDRole == ROLES.ACCOUNT_FREE_ID ? [0,2] : IDRole == ROLES.ACCOUNT_PRO_ID ? [1,2] : [-1]

    this.state = {
        IDRole : IDRole,
        step : 0,
        steps : steps,
        invoiceData : {},
        holdingData : {
            nome : "",
            descrizione : ""
        },
        userData : {
            username        : USERINFO.Username,
            password        : null,
            confirmPassword : null,
            email           : USERINFO.Email,
            id              : USERINFO.IDUser
        },
        paid : {
            success: false,
            error  : false,
            toDo   : true
        },
        payment : null,
        money : {
            currency : 'EUR', //'USD'    , // or you can set this value from your props or state
            total    : 0.01 , // same as above, this is the total amount (based on currency) to be paid by using Paypal express checkout
            selected : false,
            obj      : null
        }
    }
  }

  onFormSubmit = () => {
        var activeStep  = this.state.steps[this.state.step];
        var step        = this.state.step;
        var invoiceData = this.state.invoiceData;
        var holdingData = this.state.holdingData;
        var flag        = true;
        
        switch(activeStep){
            case 0 : 
                    //Ragione Sociale 
                    if( checkNull(invoiceData.ragioneSociale) ){
                    flag = false;
                    invoiceData.ragioneSocialeError = LABEL_Required[USERLANGUAGE];
                    }else invoiceData.ragioneSocialeError = null;
                    //Piva
                    invoiceData.pivaError = checkPivaForm(invoiceData.piva);
                    if(invoiceData.pivaError != null) flag = false;
                    //Indirizzo
                    if( checkNull(invoiceData.indirizzo) ){
                    flag = false;
                    invoiceData.indirizzoError = LABEL_Required[USERLANGUAGE];
                    }else invoiceData.indirizzoError = null;
                    //citta
                    if( checkNull(invoiceData.citta) ){
                    flag = false;
                    invoiceData.cittaError = LABEL_Required[USERLANGUAGE];
                    }else invoiceData.cittaError = null;
                    //provincia
                    if( checkNull(invoiceData.provincia) ){
                    flag = false;
                    invoiceData.provinciaError = LABEL_Required[USERLANGUAGE];
                    }else invoiceData.provinciaError = null;
                    //cap
                    invoiceData.capError = checkCapForm(invoiceData.cap);
                    if( invoiceData.capError != null ) flag = false;
                    //EMAIL
                    invoiceData.emailError = checkEmailForm(invoiceData.email);
                    if (invoiceData.emailError != null) flag = false;
                    break;
            case 1: 
                    if( checkNull(holdingData.nome) ){
                    flag = false;
                    holdingData.nomeError = LABEL_Required[USERLANGUAGE];
                    }else holdingData.nomeError = null;
                    break;
            case 2: 
                    if(this.state.paid.success){ // ti mando alla pagina di login
                        this.props.dispatch(logout());
                    }
        }
        if(flag) step++;
        this.setState({step: step, invoiceData: invoiceData, holdingData : holdingData});
  }

  backStep = () => {
      var step = this.state.step;
      if(step == 0) return;
      step--;
      this.setState({step : step});
  }

  onFormTextChange = (object, subObject, value) => {
        var obj        = this.state[object] || {};
        obj[subObject] = value;
        this.setState({[obj]: obj});
    }

  onPaymentError = err =>{
    var paid  = this.state.paid;
    paid.toDo    = false;
    paid.success = false;
    paid.erro    = true;
    this.setState({paid: paid});
  }

  onPaymentSuccess = payment =>{
    var paid = this.state.paid;
    paid.toDo    = false;
    paid.success = true;

    this.setState({paid: paid, payment : payment});

    if(this.state.IDRole === ROLES.ACCOUNT_PRO_ID){
      this.props.dispatch(registerCloud(this.state.userData, null, payment, this.state.holdingData));
    }else{
      this.props.dispatch(registerPro(this.state.userData, this.state.invoiceData, payment));
    }
  }

  onPaymentCancel = cancel =>{

  }
  
  componentDidMount = () => {
    this.props.dispatch(paymentConfig());
    this.props.dispatch(paymentPrices());
  }


  
  render() {
    var activeStep = this.state.steps[this.state.step];

    return <div>
        <ErrorMessage message={this.props.errorMessage} />
        <div className="page-container">
            <div className="paper-form-container">
                <div className="paper-form-title">
                    { activeStep == 0 ? "Dati Fatturazione" : activeStep == 1 ? LABEL_Holding[USERLANGUAGE] : "Pagamento" }
                </div>
                {   activeStep == 0 &&
                    <div>
                        <div className="paper-form-input">
                            <TextField className="input-label"
                                onChange={event => this.onFormTextChange("invoiceData", "ragioneSociale", event.target.value)}
                                hintText          = {LABEL_Enter_BusinessName[USERLANGUAGE]}
                                floatingLabelText = {LABEL_BusinessName[USERLANGUAGE]}
                                fullWidth         = {true}
                                errorText         = {this.state.invoiceData.ragioneSocialeError}
                                value             ={this.state.invoiceData.ragioneSociale}/>
                        </div>
                        
                        <div className="paper-form-input">
                            <TextField className="input-label"
                                onChange={event => this.onFormTextChange("invoiceData", "piva", event.target.value)}
                                hintText          = {LABEL_Enter_Piva[USERLANGUAGE]}
                                floatingLabelText = {LABEL_Piva[USERLANGUAGE]}
                                fullWidth         = {true}
                                errorText         = {this.state.invoiceData.pivaError}
                                value             ={this.state.invoiceData.piva}/>
                        </div>
                        
                        <div className="paper-form-input">
                            <TextField className="input-label"
                                onChange={event => this.onFormTextChange("invoiceData", "indirizzo", event.target.value)}
                                hintText          = {LABEL_Enter_Address[USERLANGUAGE]}
                                floatingLabelText = {LABEL_Address[USERLANGUAGE]}
                                fullWidth         = {true}
                                errorText         = {this.state.invoiceData.indirizzoError}
                                value             ={this.state.invoiceData.indirizzo}/>
                        </div>
                        
                        <div className="paper-form-input">
                            <TextField className="input-label"
                                onChange={event => this.onFormTextChange("invoiceData", "citta", event.target.value)}
                                hintText          = {LABEL_Enter_City[USERLANGUAGE]}
                                floatingLabelText = {LABEL_City[USERLANGUAGE]}
                                fullWidth         = {true}
                                errorText         = {this.state.invoiceData.cittaError}
                                value             ={this.state.invoiceData.citta}/>
                        </div>
                        
                        <div className="paper-form-input">
                            <TextField className="input-label"
                                onChange={event => this.onFormTextChange("invoiceData", "provincia", event.target.value)}
                                hintText          = {LABEL_Enter_District[USERLANGUAGE]}
                                floatingLabelText = {LABEL_District[USERLANGUAGE]}
                                fullWidth         = {true}
                                errorText         = {this.state.invoiceData.provinciaError}
                                value             ={this.state.invoiceData.provincia}/>
                        </div>
                        
                        <div className="paper-form-input">
                            <TextField className="input-label"
                                onChange={event => this.onFormTextChange("invoiceData", "cap", event.target.value)}
                                hintText          = {LABEL_Enter_Cap[USERLANGUAGE]}
                                floatingLabelText = {LABEL_Cap[USERLANGUAGE]}
                                fullWidth         = {true}
                                errorText         = {this.state.invoiceData.capError}
                                value             ={this.state.invoiceData.cap}/>
                        </div>
                        
                        <div className="paper-form-input">
                            <TextField className="input-label"
                                onChange={event => this.onFormTextChange("invoiceData", "email", event.target.value)}
                                hintText          = {LABEL_Enter_Email[USERLANGUAGE]}
                                floatingLabelText = {LABEL_Email[USERLANGUAGE]}
                                fullWidth         = {true}
                                errorText         = {this.state.invoiceData.emailError}
                                value             = {this.state.invoiceData.email}/>
                        </div>

                        
                    </div>
                }

                { // HOLDING
                    activeStep == 1 &&
                    <div>
                        <div className="paper-form-input">
                            <TextField className="input-label"
                                onChange={event => this.onFormTextChange("holdingData", "nome", event.target.value)}
                                hintText          = {LABEL_Enter_Name[USERLANGUAGE]}
                                floatingLabelText = {LABEL_Name[USERLANGUAGE]}
                                fullWidth         = {true}
                                errorText         = {this.state.holdingData.nomeError}
                                value             = {this.state.holdingData.nome}/>
                        </div>
                        <div className="paper-form-input">
                            <TextField className="input-label"
                                onChange={event => this.onFormTextChange("holdingData", "descrizione", event.target.value)}
                                hintText          = {LABEL_Enter_Description[USERLANGUAGE]}
                                floatingLabelText = {LABEL_Description[USERLANGUAGE]}
                                fullWidth         = {true}
                                errorText         = {this.state.holdingData.descrizioneError}
                                value             = {this.state.holdingData.descrizione}/>
                        </div>
                    </div>

                }

                { // PAGAMENTO
                    activeStep == 2 && this.state.paid.toDo && 
                    <div className="paypal-btn">
                        <PaypalExpressBtn 
                            env       = {this.props.paypalConfig.Environment} 
                            client    = {this.props.paypalConfig.Client}
                            currency  = {this.state.money.currency}
                            total     = {this.state.money.total}
                            onError   = {this.onPaymentError}
                            onSuccess = {this.onPaymentSuccess}
                            onCancel  = {this.onPaymentCancel} />
                    </div>
                    ||
                    activeStep == 2 && this.state.paid.success &&
                    <div className="payment-success">
                        <div className="checkmark payment-success-checkmark"></div>
                        <div className="payment-success-label">{LABEL_PaymentOK[USERLANGUAGE]}</div>
                    </div>
                }
                
                <div className="btn-nav clearfix">
                    <div className="btn-nav-back">
                        { this.state.paid.toDo && this.state.step != 0 && 
                            <RaisedButton
                            icon={<IconArrowBack/>}
                            primary={true}
                            fullWidth={true}
                            onClick={this.backStep}
                        />}
                    </div>
                    <div className="btn-nav-forward">
                        { this.state.paid.toDo && this.state.step < this.state.steps.length-1 &&
                            <RaisedButton
                            icon={<IconArrowForward/>}
                            primary={true}
                            fullWidth={true}
                            onClick={this.onFormSubmit}
                        />}
                        { this.state.paid.success && this.state.step < this.state.steps.length &&
                            <RaisedButton
                            icon={<IconCheck/>}
                            primary={true}
                            fullWidth={true}
                            onClick={this.onFormSubmit}
                        />}
                    </div>
                </div>
            </div>
                
        </div>
      </div>;
  }
}

function mapStateToProps(state) {
  const { upgradeReducer } = state;
  const { isFetching, errorMessage, paypalConfig, paypalPriceList } = upgradeReducer;
  return {
    isFetching,
    errorMessage,
    paypalConfig,
    paypalPriceList
  };
}

export default connect(mapStateToProps)(Upgrade);



// WEBPACK FOOTER //
// ./src/Containers/Upgrade.js